import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const auth = {
  login: (username, password) =>
    api.post('/auth/login', { username, password }),
  register: (data) =>
    api.post('/auth/register', data),
  getCurrentUser: () =>
    api.get('/me'),
};

export const folders = {
  list: () =>
    api.get('/folders/list'),
  get: (id) =>
    api.get(`/folders/get/${id}`),
  create: (parentId, name) =>
    api.post(`/folders/create/${parentId}`, { name }),
};

export const files = {
  upload: (folderId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/files/upload/${folderId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  delete: (fileId) =>
    api.delete(`/files/delete/${fileId}`),
};

export const permissions = {
  grant: (data) =>
    api.post('/permissions/grant', data),
  revoke: (accessId) =>
    api.delete(`/permissions/revoke/${accessId}`),
};

export const activities = {
  list: () =>
    api.get('/activities/list'),
};

export default api;
